import Router from "next/router";
import { useEffect } from "react";
import { useUnsavedWorkMessage } from ".";

export const useWarnBeforeRouteChangeIfUnsavedWork = () => {
  const { message } = useUnsavedWorkMessage();

  useEffect(() => {
    const handleRouteChange = () => {
      if (message && !window.confirm(message)) {
        Router.events.emit("routeChangeError");
        // eslint-disable-next-line lingui/no-unlocalized-strings
        throw "routeChange aborted: [unsaved work]";
      }
    };

    Router.events.on("routeChangeStart", handleRouteChange);
    return () => Router.events.off("routeChangeStart", handleRouteChange);
  }, [message]);
};
